import * as Yup from 'yup';

const usersValidationSchema = () => {
  let baseSchema = {
    groupName: Yup.string()
      .max(50, 'Group Name must be at most 50 characters')
      .required('Group Name is required'),
    description: Yup.string().required('Description is required'),
    rolesAndPermissions: Yup.string().required('Role is required'),
    botId: Yup.string().required('Chatbot is required'),
  };
  return Yup.object().shape(baseSchema);
};
export default usersValidationSchema;
